import api from './auth';

// Admin Badge Management API
export const adminBadgeAPI = {
    // Get all badges with pagination
    getAllBadges: (page = 0, size = 10, sort = 'name,asc') => {
        return api.get('/api/admin/badges', {
            params: { page, size, sort }
        });
    },

    // Get specific badge by ID
    getBadgeById: (id) => {
        return api.get(`/api/admin/badges/${id}`);
    },

    // Create new badge
    createBadge: (badgeData) => {
        return api.post('/api/admin/badges', badgeData);
    },

    // Update existing badge
    updateBadge: (id, badgeData) => {
        return api.put(`/api/admin/badges/${id}`, badgeData);
    },

    // Soft delete badge (deactivate)
    deleteBadge: (id) => {
        return api.delete(`/api/admin/badges/${id}`);
    },

    // Toggle badge active status
    toggleBadgeStatus: (id) => {
        return api.patch(`/api/admin/badges/${id}/toggle-status`);
    },

    // Get available badge categories
    getCategories: () => {
        return api.get('/api/admin/badges/categories');
    },

    // Get available badge rarities
    getRarities: () => {
        return api.get('/api/admin/badges/rarities');
    },

    // Get available emoji icons
    getAvailableIcons: () => {
        return api.get('/api/admin/badges/icons/available');
    }
};

export default adminBadgeAPI;
